var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRcs = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_5326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97484 9.23801C11.226 9.23801 13.047 7.31704 13.047 4.95232C13.047 2.5876 11.226 0.666626 8.97484 0.666626H4.73817C2.48699 0.666626 0.666016 2.58753 0.666016 4.95232C0.666016 7.31711 2.48699 9.23808 4.73817 9.23808L8.97484 9.23801ZM4.73817 7.63808L8.97481 7.63801C10.2652 7.63801 11.447 6.51255 11.447 4.95232C11.447 3.39209 10.2652 2.26663 8.97484 2.26663H4.73817C3.44777 2.26663 2.26602 3.39204 2.26602 4.95232C2.26602 6.51263 3.44781 7.63807 4.73817 7.63808C4.73818 7.63808 4.73816 7.63808 4.73817 7.63808Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8184 12.3052V14.9186C8.8184 15.1459 8.63528 15.3352 8.41576 15.3352C8.30833 15.3345 8.2059 15.29 8.13194 15.2121L4.16048 11.1216C3.38264 10.3264 2.95264 9.23759 2.95264 8.11064C2.95264 5.79085 4.77361 3.90662 7.02479 3.90662H11.2615C13.5126 3.90662 15.3336 5.79092 15.3336 8.11064C15.3336 10.4304 13.5126 12.3147 11.2615 12.3147H8.8184V12.3052Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_5326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRcs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RCS.41fd2ae9c6841e262f3953b591ec664d.svg";